import React from 'react';

import { IconButton, useMediaQuery } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';

import api from '~/services/api';

import VisaoGeral from './VisaoGeral';

export default function DashboardVisaoGeral() {
  const isDesktop = useMediaQuery('(min-width:769px)');

  const handleOpenNewWindow = () => {
    const windowRef = window.open(
      '/dashboardvisaogeral_fullscreen',
      '_blank',
      'toolbar=0,location=0,menubar=0'
    );

    const receiveReadyMessage = (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data.type === 'READY') {
        // Recebe a confirmacao da prontidao da janela maximizada
        const auth = {
          token: api.defaults.headers.token,
          signed: true,
          loading: false,
        };
        windowRef.postMessage({ auth }, window.location.origin);
        window.removeEventListener('message', receiveReadyMessage);
      }
    };

    window.addEventListener('message', receiveReadyMessage);
  };

  return (
    <VisaoGeral
      headerIcon={
        isDesktop ? (
          <IconButton
            aria-label="Abrir nova janela"
            onClick={handleOpenNewWindow}
          >
            <OpenInNew />
          </IconButton>
        ) : null
      }
    />
  );
}
